import React, { useEffect, useRef, useState } from "react";
import "./Offer.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { Link, useLocation } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const OfferSection = ({ defaultTab = "All" }) => {
  const swiperRef = useRef(null);
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const tabs = ["All", "Flights", "Hotels", "Holidays", "Cabs", "Bus"];

  // 🌐 Fetch Offers API
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const res = await axios.get(
          "https://admin.travelsdata.com/api/AllOffers"
        );
        if (res.data.success && res.data.data) {
          setOffers(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching offers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOffers();
  }, []);

  // 🧭 Detect path and adjust filter behavior
  useEffect(() => {
    const path = location.pathname.toLowerCase();

    if (path === "/") {
      setActiveTab("All");
    } else if (path.includes("hotel")) {
      setActiveTab("Hotels");
    } else if (path.includes("bus")) {
      setActiveTab("Bus");
    } else if (path.includes("tour")) {
      setActiveTab("Holidays");
    } else if (path.includes("cab")) {
      setActiveTab("Cabs");
    } else {
      setActiveTab("All");
    }
  }, [location.pathname]);

  // 🧮 Filter logic
  const filteredData = offers.filter((item) => {
    if (activeTab === "All") return true;
    return item.offer_type?.toLowerCase().includes(activeTab.toLowerCase());
  });

  // 💀 Skeleton slides
  const skeletonSlides = Array(5)
    .fill(0)
    .map((_, index) => (
      <SwiperSlide key={index} style={{ width: 306, marginRight: 24 }}>
        <div className="sc-1bhhs5y-1 hHlOgt">
          <Skeleton height={200} />
          <div style={{ padding: "10px 0" }}>
            <Skeleton height={20} width={100} />
            <Skeleton height={15} width={80} style={{ marginTop: 8 }} />
          </div>
        </div>
      </SwiperSlide>
    ));

  return (
    <div className="GI_OFFERS_B2C_IN_V2 TG_OFFERS_B2C_IN_V2">
      <div className="sc-1bhhs5y-25 ddXIaO">
        <div className="sc-1umf7nv-105 igBafX">
          <div className="sc-1umf7nv-106 jwmxBc">
            <div className="sc-1umf7nv-107 bIEKkd">
              <h2 className="sc-jXbUNg dRpmLD">Offers For You</h2>
            </div>
            <div className="sc-1umf7nv-108 dqZfcT">
              <div className="sc-1umf7nv-109 iKvWs">
                <Link className="sc-imWYAI bHoRkw" to="/offers">
                  View All
                </Link>
              </div>
            </div>
          </div>

          {/* ✅ Show tabs only on home route */}
          {location.pathname === "/" && (
            <ul className="sc-1umf7nv-111 kFlkOL">
              {tabs.map((tab) => (
                <li
                  key={tab}
                  className={`sc-1umf7nv-112 eqzCTD ${
                    activeTab === tab ? "active" : ""
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Navigation Arrows */}
      {!loading && (
        <>
          <div
            className="custom-prev3"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <FaChevronLeft />
          </div>
          <div
            className="custom-next3"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <FaChevronRight />
          </div>
        </>
      )}

      {/* 🌀 Swiper Section */}
      <Swiper
        spaceBetween={10}
        breakpoints={{
          0: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }}
        autoplay={{ delay: 3000 }}
        loop={!loading}
        modules={[Autoplay]}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        className="mySwiper"
        style={{ paddingBottom: "20px" }}
      >
        {loading
          ? skeletonSlides
          : filteredData.map((item, index) => (
              <SwiperSlide key={index} style={{ width: 306, marginRight: 24 }}>
                <div className="sc-1bhhs5y-1 hHlOgt">
                  {item.url && item.url !== "#" ? (
                    <Link
                      className="sc-1bhhs5y-2 jWnEia"
                      to={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="sc-1bhhs5y-3 ewsLKf">
                        <img
                          alt="offer img"
                          src={item.image}
                          loading="lazy"
                          className="sc-1bhhs5y-4 fxtiol"
                        />
                      </div>
                      <div className="sc-1bhhs5y-5 cPvMEt">
                        <p className="sc-1bhhs5y-6 eQulyt">{item.offer_type}</p>
                        <p className="sc-1bhhs5y-8 hSlkMg">{item.name}</p>
                      </div>
                    </Link>
                  ) : (
                    <div className="sc-1bhhs5y-2 jWnEia">
                      <div className="sc-1bhhs5y-3 ewsLKf">
                        <img
                          alt="offer img"
                          src={item.image}
                          loading="lazy"
                          className="sc-1bhhs5y-4 fxtiol"
                        />
                      </div>
                      <div className="sc-1bhhs5y-5 cPvMEt">
                        <p className="sc-1bhhs5y-6 eQulyt">{item.offer_type}</p>
                        <p className="sc-1bhhs5y-8 hSlkMg">{item.name}</p>
                      </div>
                    </div>
                  )}
                </div>
              </SwiperSlide>
            ))}
      </Swiper>
    </div>
  );
};

export default OfferSection;
